// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 100%;
}

ion-card ion-card-header div.ion-card-header-extra {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
ion-card ion-card-header div.ion-card-header-extra-badge {
  justify-self: right;
}
ion-card ion-card-header ion-badge {
  margin-left: 4px;
  margin-top: 4px;
}
ion-card ion-card-title {
  white-space: nowrap;
  overflow: hidden !important;
  text-overflow: ellipsis;
}
ion-card ion-card-subtitle {
  color: black;
}
ion-card ion-card-content {
  color: black;
}

.none {
  --background: #8F9094;
}

.initial {
  --background: #1dad94;
}

.quoted {
  --background: #1c33a3;
}

.pending {
  --background: #30a2db;
}

.approved {
  --background: #45b020;
}

.completed {
  --background: #b0af20;
}

.pending-internal-approval {
  --background: #354960;
}

.internally-approved {
  --background: #30a2db;
}

.sent-to-customer {
  --background: #8e1ca3;
}

.customer-approved {
  --background: #45b020;
}

.customer-declined {
  --background: #be252e;
}

.service-call-created {
  --background: #b0af20;
}

.deleted {
  color: var(--ion-color-danger);
}`, "",{"version":3,"sources":["webpack://./src/app/components/quote-card/quote-card.component.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;AACJ;;AAKQ;EACI,aAAA;EACA,8BAAA;AAFZ;AAKQ;EACI,mBAAA;AAHZ;AAMQ;EACI,gBAAA;EACA,eAAA;AAJZ;AAQI;EACI,mBAAA;EACA,2BAAA;EACA,uBAAA;AANR;AASI;EACI,YAAA;AAPR;AAUI;EACI,YAAA;AARR;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,qBAAA;AAVJ;;AAaA;EACI,8BAAA;AAVJ","sourcesContent":[":host {\r\n    width: 100%;\r\n}\r\n\r\nion-card {\r\n\r\n    ion-card-header {\r\n        div.ion-card-header-extra {\r\n            display: grid;\r\n            grid-template-columns: 1fr 1fr;\r\n        }\r\n\r\n        div.ion-card-header-extra-badge {\r\n            justify-self: right;\r\n        }\r\n\r\n        ion-badge {\r\n            margin-left: 4px;\r\n            margin-top: 4px;\r\n        }\r\n    }\r\n\r\n    ion-card-title {\r\n        white-space: nowrap;\r\n        overflow: hidden !important;\r\n        text-overflow: ellipsis;\r\n    }\r\n\r\n    ion-card-subtitle {\r\n        color: black;\r\n    }\r\n\r\n    ion-card-content {\r\n        color: black;\r\n    }\r\n}\r\n\r\n\r\n.none {\r\n    --background: #8F9094;\r\n}\r\n\r\n.initial {\r\n    --background: #1dad94;\r\n}\r\n\r\n.quoted {\r\n    --background: #1c33a3;\r\n}\r\n\r\n.pending {\r\n    --background: #30a2db;\r\n}\r\n\r\n.approved {\r\n    --background: #45b020;\r\n}\r\n\r\n.completed {\r\n    --background: #b0af20;\r\n}\r\n\r\n.pending-internal-approval {\r\n    --background: #354960;\r\n}\r\n\r\n.internally-approved {\r\n    --background: #30a2db;\r\n}\r\n\r\n.sent-to-customer {\r\n    --background: #8e1ca3;\r\n}\r\n\r\n.customer-approved {\r\n    --background: #45b020;\r\n}\r\n\r\n.customer-declined {\r\n    --background: #be252e;\r\n}\r\n\r\n.service-call-created {\r\n    --background: #b0af20;\r\n}\r\n\r\n.deleted {\r\n    color: var(--ion-color-danger);\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
